module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-reports/sainik-reports.component.css
// module id = ./src/app/sainik-reports/sainik-reports.component.css
// module chunks = main